import React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon';
import { Paragraph, ParagraphProps } from '../Paragraph';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export type DeliveryTypeProps = ParagraphProps;

export const StyledDeliveryType = ({ text }: DeliveryTypeProps) => {
  return (
    <Wrapper>
      <Icon matIcon="location_on" outlined />
      <Paragraph text={text} />
    </Wrapper>
  );
};
